import React from "react";
import { Link } from "react-router-dom";
import "./SignedOutFeature.css";

export default function SignedOutFeature({ feature = "this feature" }) {
  return (
    <main className="signedOutFeature">
      <div className="signedOutPreview" aria-hidden="true">
        <div className="signedOutPreviewTop"><i /><i /><i /><span>{feature} preview</span></div>
        <div className="signedOutPreviewBody">
          <div className="signedOutSkeleton signedOutSkeletonHero" />
          <div className="signedOutSkeletonGrid"><i /><i /><i /></div>
          <div className="signedOutSkeleton signedOutSkeletonLine" />
          <div className="signedOutSkeleton signedOutSkeletonLine short" />
        </div>
      </div>
      <section className="signedOutCard">
        <span className="signedOutLock">⌁</span>
        <small>MEMBERS-ONLY WORKSPACE</small>
        <h1>Sign in to use {feature}</h1>
        <p>Your workspace and personal data are kept private. Sign in to continue, or create a free account to get started.</p>
        <div><Link to="/SignIn">Sign in <span>→</span></Link><Link to="/SignUp">Create account</Link></div>
      </section>
    </main>
  );
}
